import { render, staticRenderFns } from "./ViewEvents.vue?vue&type=template&id=1108b1e9&scoped=true&"
import script from "./ViewEvents.vue?vue&type=script&lang=ts&"
export * from "./ViewEvents.vue?vue&type=script&lang=ts&"
import style0 from "./ViewEvents.vue?vue&type=style&index=0&id=1108b1e9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1108b1e9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
